var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: "v-message-fade" },
      on: { "after-leave": _vm.handleAfterLeave },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          class: ["v-message", ..._vm.messageClass],
          style: _vm.positionStyle,
          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer },
        },
        [
          _vm.showIcon
            ? [
                _vm.icon
                  ? [_c("i", { class: ["v-message__icon", _vm.icon] })]
                  : _vm.type !== "loading"
                  ? [
                      _c("i", {
                        class: [
                          "v-message__icon",
                          `v-message__icon--${_vm.type}`,
                          _vm.typeClass,
                        ],
                      }),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "v-message__loading" },
                        [
                          _c("v-loading", {
                            attrs: { size: "S", visible: true },
                          }),
                        ],
                        1
                      ),
                    ],
              ]
            : _vm._e(),
          _vm._t("default", function () {
            return [
              !_vm.dangerouslyUseHTMLString
                ? _c("p", { class: _vm.contentClass }, [
                    _vm._v(" " + _vm._s(_vm.content) + " "),
                  ])
                : _c("p", {
                    class: _vm.contentClass,
                    domProps: { innerHTML: _vm._s(_vm.content) },
                  }),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }